module.exports = "<div class=container> <div class=\"jumbotron mt100\"> <h1 class=text-center>404 Not Found<p> </p><p><small class=text-center> Oh noes everything broke</small></p></h1> <p class=text-center>Try pressing the back button or clicking on this button.</p> <p class=text-center><a class=\"btn btn-primary\" href=/ ><i class=\"fa fa-home\"></i> Take Me Home</a></p> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./travel-developers-interface/src/main/client/static/content/error404.html
// module id = 7217189229661154
// module chunks = 0 2 3